import React from 'react';
import PropTypes from 'prop-types';
import { ClickWrapper } from '@/components/HeaderHero';
import { HeroContent } from '@/components/HeaderHero/HeroContent';
import getSourceSetValues from '@/helpers/getSourceSetValues';
import { resizeImageSourceMax } from '@/helpers/resizeImageSource';

import * as S from './styled';

export const Teaser = ({ data }) => {
  const { url, imageUrl, title, readMoreText } = data;

  return (
    <ClickWrapper url={url} type="Image" title={title}>
      {readMoreText && (
        <HeroContent
          title={title}
          url={url}
          readMore={readMoreText}
          type="image_teaser"
        />
      )}
      <S.ImageWrapper>
        <img
          srcSet={getSourceSetValues(imageUrl).join(', ')}
          src={resizeImageSourceMax(imageUrl)}
          sizes="((orientation: portrait) and (max-width: 480px) 480px )"
          alt={` `}
        />
      </S.ImageWrapper>
    </ClickWrapper>
  );
};

Teaser.propTypes = {
  data: PropTypes.shape({
    url: PropTypes.string.isRequired,
    imageUrl: PropTypes.string.isRequired,
    title: PropTypes.string.isRequired,
    readMoreText: PropTypes.string.isRequired,
  }).isRequired,
};
